"use strict";

module.exports = {
  modal: 1300,
  snackbar: 1400,
  drawer: 1200,
  appBar: 1100,
  mobileStepper: 1000,
  tooltip: 1500
};
//# sourceMappingURL=z-index.js.map